module.exports = __webpack_public_path__ + "img/ok-form.7b31ccc8.svg";